export default __webpack_public_path__ + "static/media/my.86044c68.svg";